<template>
    <div class="order-wrapper" v-if="orders && orders.length>0">
        <div v-for="(order,index) in orders" class="order-card">
            <router-link :to="{name:'orderInfo',params:order}">
                <div class="order-header">
                    <div class="order-header-left">
                        <h3>{{order.name}}</h3>
                    </div>
                    <div class="order-header-right">
                        <span class="order-status">{{order.appointStatus | orderStatus}}</span>
                    </div>
                </div>
                <div class="order-content">
                    <div class="order-content-item">
                        <span class="order-content-item-text">体检套餐</span>
                        <span class="order-content-item-value">{{order.packageName}}</span>
                    </div>
                    <div class="order-content-item">
                        <span class="order-content-item-text">体检金额</span>
                        <span class="order-content-item-value">￥{{order.totalPrice.toFixed(2)}}</span>
                    </div>
                    <div class="order-content-item">
                        <span class="order-content-item-text">支付状态</span>
                        <span class="order-content-item-value">{{order|payStatus}}</span>
                    </div>
                    <div class="order-content-item">
                        <span class="order-content-item-text">体检日期</span>
                        <span class="order-content-item-value">{{order.appointDate}}
                            {{order.appointTimeRangeName}}</span>
                    </div>
                </div>
            </router-link>
            <div class="order-footer">
                <van-button type="danger" size="small" plain hairline round @click="cancelOrder(order)"
                    style="margin-right:16px" v-if="order.appointStatus == 1">取消预约
                </van-button>
                <van-button type="default" size="small" round
                    @click="$router.push({name:'orderInfo',params:order})">查看详情</van-button>
            </div>
        </div>

        <!-- loading遮罩层 -->
        <van-overlay :show="showOverlay">
            <div class="overlay-wrapper" @click.stop>
                <van-loading type="spinner" color="#fff" />
            </div>
        </van-overlay>

    </div>
    <div class="order-wrapper" v-else>
        <div class="oder-empty-wrapper">
            <van-empty description="无预约记录" />
        </div>
    </div>
</template>

<style lang="less" scoped>
    .order-wrapper {
        padding: 0 12px 24px 12px;
    }

    .order-card {
        border-radius: 8px;
        background: #fff;
        margin-top: 16px;
        padding: 16px;

        .order-header {
            display: flex;
            border-bottom: 1px solid #ebedf0;
            padding-bottom: 8px;
            margin-bottom: 8px;

            .order-header-left {
                flex: 1;

                h3 {
                    font-size: 15px;
                    font-weight: 500;
                }

                .team-title {
                    font-size: 14px;
                    color: #888;
                }
            }

            .order-header-right {
                font-size: 14px;
                margin: auto 0;

                .order-status {
                    color: @orange;
                }
            }
        }

        .order-content {
            font-size: 14px;
            line-height: 28px;

            .order-content-item {
                padding: 2px 0;
            }

            .order-content-item-text {
                margin-right: 24px;
                color: #969799;
            }

            .order-content-item-value {
                color: #646566;
            }
        }

        .order-footer {
            padding-top: 8px;
            border-top: 1px solid #ebedf0;
            text-align: right;
        }
    }

    .overlay-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
</style>


<script>
    import * as user_api from '@/api/user'
    import * as order_api from '@/api/order'
    import {
        mapState,
        mapMutations,
        mapActions
    } from "vuex";
    export default {
        name: "orderListComponent",
        data() {
            return {
                showOverlay: false,
            };
        },
        props: {
            orders: Array
        },
        mounted() {},
        computed: {
            ...mapState({
                hospInfo: state => state.hospital.hospInfo
            })
        },
        methods: {
            cancelOrder(order) {
                // if (order.payment > 0 && order.payStatus == 1) {
                //     this.$toast.fail("取消预约暂不支持退款，请联系体检中心。")
                //     return
                // }
                this.showOverlay = true;
                this.$Dialog.confirm({
                        message: '是否取消预约？',
                        "cancelButtonText": "我再想想",
                        "confirmButtonText": "取消预约",
                    })
                    .then(() => {
                        order_api.cancelOrder(order.orderNo).then(res => {
                            console.log(res);
                            this.$toast(res.msg);
                            this.$emit('onDataChanged');
                            this.showOverlay = false;
                        })
                    })
                    .catch(() => {
                        this.showOverlay = false;
                    });
            },
        },
        filters: {
            orderStatus: function (value) {
                if (!value) return ''
                switch (value) {
                    case 1:
                        return "已预约"
                        break;
                    case 2:
                        return "已体检"
                        break;
                    case 9:
                        return "已取消"
                        break;
                    default:
                        return ""
                        break;
                }
            },
            payStatus: function (order) {
                if (order.payment == 0) {
                    return "现场支付"
                } else {
                    if (order.payStatus == 0) {
                        return "未支付"
                    } else if (order.payStatus == 1) {
                        return "已支付"
                    } else if (order.payStatus == 2) {
                        return "退款中"
                    } else if (order.payStatus == 3) {
                        return "退款成功"
                    } else if (order.payStatus == 9) {
                        return "交易关闭"
                    }
                }
            },
        }
    };
</script>